

function DynamicTTS(){
    return(
        <h1>DynamicTTS Page</h1>
    );
}

export default DynamicTTS;